<template>
  <div ref="chart">
    <div
      v-if="isShowCustomTitle"
      class="custom-legend-title">
      <i class="uil uil-list-ul me-1"></i>
      Legend
    </div>
    <div
      v-for="(legend, index) in legendData"
      :key="'legend-item-'+ index"
      class="legend-item"
      :class="{
        selectable: isSelectable,
        selected: legend.selected === true,
        unselected: legend.selected === false
      }"
      @mouseover="onLegendItemMouseOver(legend)"
      @mouseleave="onLegendItemMouseOver(undefined)"
      @click="onLegendItemClick(legend)">
      <div class="legend-item-container">
        <div
        :style="{
          'background-color': `${legend.color}`,
          'border-color': legend.border ? `${legend.border}` : 'lightgrey'
        }"
        class="legend-bubble"></div>
        <span class="legend-label">{{legend.label}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3';

export default {
  name: 'ChartLegend',
  props: {
    input: {
      type: String
      // default:
      // '{"data":[{"color":"#d7191c","label":"Below average X Above average inequality"},{"color":"#fdae61","label":"Above average X Above average inequality"},{"color":"#abd9e9","label":"Below average X Below average inequality"},{"color":"#2c7bb6","label":"Above average X Below average inequality"}]}',
      // '{"data":[{"color":"#d7191c","label":"Below average X","label2":"Above average inequality"},{"color":"#fdae61","label":"Above average X","label2":"Above average inequality"},{"color":"#abd9e9","label":"Below average X","label2":"Above average inequality"},{"color":"#2c7bb6","label":"Above average X","label2":"Above average inequality"}]}'
    },
    isHoverable: {
      type: Boolean, default: false
    },
    isSelectable: {
      type: Boolean, default: false
    },
    isShowCustomTitle: {
      type: Boolean, default: false
    }
  },
  // the component's data
  data () {
    return {
      margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      color: {},
      vis: [],
      width: 15,
      label_font_style: 'sans-serif',
      label_font_size: 13,
      legendData: []
    };
  },
  // You can do whatever when the selected node changes
  watch: {
    selectedNode (newData, oldData) {
      console.log('The selected node changed...', newData, oldData);
    },
    input (newData, oldData) {
      this.initialize();
    }
  },
  mounted () {
    this.initialize();
  },
  methods: {
    getTextWidth: function (text, fontSize, fontStyle) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = fontSize + 'px ' + fontStyle;
      return context.measureText(text).width;
    },
    setNoDataText: function () {
      this.$refs.chart.innerHTML = '<p style="text-align: center;">NO DATA</p>';
    },
    onMouseOver: function (e, data) {
      console.log('e', e, data);
      this.$emit('sendMouseOver', data);
    },
    onMouseOut: function (e, data) {
      console.log('e', e, data);
      this.$emit('sendMouseOver', data);
    },
    onLegendItemMouseOver: function (legendItem) {
      if (this.isHoverable) {
        // console.log('legendItem', legendItem);
        this.$emit('onLegendItemMouseOver', legendItem);
      }
    },
    onLegendItemClick: function (legendItem) {
      if (this.isSelectable) {
        // console.log('legendItem', legendItem);
        this.$emit('onLegendItemClick', legendItem);
      }
    },
    initialize () {
      const self = this;
      this.legendData = [];
      let tempData;
      const marginTop = 17;
      try {
        tempData = JSON.parse(self.input);
      } catch (error) {
        self.setNoDataText();
        return;
      }
      let data = [];
      if (tempData && tempData.data) data = tempData.data;
      else {
        self.setNoDataText();
        return;
      }

      this.legendData = data;
    }
  }
};
</script>

<style lang="scss">
.legend-item {
  &.selectable {
    cursor: pointer;
    :hover {
      font-weight: bold;
    }
  }
  &.selected {
    .legend-item-container {
      padding-left: 3px;
      padding-right: 3px;
      background: lightgray;
      border-radius: 5px;
    }
    .legend-bubble {
    }
  }
  &.unselected {
    opacity: 0.5;
    // .legend-bubble {
    //   opacity: 50%;
    //
  }
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Roboto';
}
.legend-bubble {
  z-index: 1000;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 4px;
  border: 1px solid lightgrey;
  opacity: 1;
}
.custom-legend-title {
  display: inline-block !important;
  margin-right: 20px;
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: bold;
  font-family: "Roboto";
}
</style>
